import loadable from '@loadable/component';

export const WindowscentralSiteWrapper = loadable(
  () => import(/* webpackChunkName: "windowscentral-site" */ './WindowscentralSiteWrapper'),
);
